import { render, staticRenderFns } from "./QuotationsWinners.html?vue&type=template&id=78b2fc72&scoped=true&"
import script from "./QuotationsWinners.js?vue&type=script&lang=js&"
export * from "./QuotationsWinners.js?vue&type=script&lang=js&"
import style0 from "./QuotationsWinners.scss?vue&type=style&index=0&id=78b2fc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2fc72",
  null
  
)

export default component.exports